import React, { useState, useEffect, useCallback } from 'react';

import HeaderBackButton from './HeaderBackbutton';

import NextImageArrow from '../assets/images/arrow_cursor.png';

import { HomeContainer } from '../styled-components/homestyle';

import {
  ArtprojectContainer,
  ArtprojectTextWrapper,
  ArtprojectImageWrapper,
  ArtprojectInfo,
  ArtprojectText,
  ArtprojectLink,
  ArtProjectImage,
  NextImageButton,
  NextImageButtonArrow
} from '../styled-components/artprojectstyle';

const Artproject = ({ artproject }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNextImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === artproject.images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const nextSlide = useCallback(() => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % artproject.images.length);
  }, [artproject.images.length]);
  
  useEffect(() => {
    const intervalId = setInterval(nextSlide, 6000);
  
    return () => clearInterval(intervalId);
  }, [currentIndex, nextSlide]); 

  return (
    <HomeContainer>
      <HeaderBackButton />
      <ArtprojectContainer>
        <ArtprojectImageWrapper>
          {artproject.images && Array.isArray(artproject.images) && (
            <ArtProjectImage
              src={artproject.images[currentIndex]}
              alt={`Image${currentIndex + 1}`}
            />
          )}
          <ArtprojectText>{currentIndex + 1}/{artproject.images.length}</ArtprojectText>
          <NextImageButton onClick={handleNextImage}>
            <NextImageButtonArrow src={NextImageArrow} alt={`Next`} />
          </NextImageButton>
        </ArtprojectImageWrapper>
        <ArtprojectTextWrapper>
          <ArtprojectInfo>
            {artproject.info.map((line, index) => (
              <React.Fragment key={index}>{line}, </React.Fragment>
            ))}
            </ArtprojectInfo>
          <ArtprojectText>{artproject.text}</ArtprojectText>
          {artproject.path === 'dreamisland' && (
        <ArtprojectText>Read publication online <ArtprojectLink href="https://su.diva-portal.org/smash/get/diva2:1337949/FULLTEXT01" target="_blank" rel="noopener noreferrer" aria-label="go to Dream Island publication" alt="Publication online">here</ArtprojectLink>.</ArtprojectText>
          )}
          {artproject.path === 'bibliotek' && (
        <ArtprojectText>Visit Magasin IIIs website to read more on the project <ArtprojectLink href="https://magasin3.com/exhibition/konst-i-biblioteket-fatima-moallim/" target="_blank" rel="noopener noreferrer" aria-label="go to Magasin III website" alt="Magasin III website">here</ArtprojectLink>.</ArtprojectText>
          )}
          {artproject.path === 'skinofthesoul' && (
        <ArtprojectText>Visit Magasin IIIs website to read more on the exhibition <ArtprojectLink href="https://magasin3.com/exhibition/skin-of-the-soul_01/" target="_blank" rel="noopener noreferrer" aria-label="go to Magasin III website" alt="Magasin III website">here</ArtprojectLink>.
        Read folder online <ArtprojectLink href="https://cdn.magasin3.com/uploads/2023/09/folder_skin-of-the-soul_20230831_sve.pdf/" target="_blank" rel="noopener noreferrer" aria-label="Skin of the Soul folder" alt="Skin of the Soul folder">here</ArtprojectLink>.</ArtprojectText>
          )}
          {artproject.path === 'glossary' && (
        <ArtprojectText>Visit Magasin IIIs website to read more on the exhibition <ArtprojectLink href="https://magasin3.com/exhibition/meric-algun-a-glossary-of-distance-and-desire/" target="_blank" rel="noopener noreferrer" aria-label="go to Magasin III website" alt="Magasin III website">here</ArtprojectLink>.
        Read folder online <ArtprojectLink href="https://cdn.magasin3.com/uploads/2023/04/folder_meric-algun_a-glossary-of-distance-and-desire_sv.pdf" target="_blank" rel="noopener noreferrer" aria-label="Glossary of Distance and Desire folder" alt="Glossary of Distance and Desire folder">here</ArtprojectLink>.</ArtprojectText>
          )}
          {artproject.path === 'borderland' && (
        <ArtprojectText>Visit Magasin IIIs website to read more on the project <ArtprojectLink href="https://magasin3.com/exhibition/handelshogskolan-x-magasin-3/" target="_blank" rel="noopener noreferrer" aria-label="go to Magasin III website" alt="Magasin III website">here</ArtprojectLink>.</ArtprojectText>
          )}
          {artproject.path === 'artworks' && (
        <ArtprojectText>Visit online exhibition <ArtprojectLink href="https://artworks.se/utstallningar/curated-by-sofia-ringstedt" target="_blank" rel="noopener noreferrer" aria-label="go to Artworks website" alt="Artworks website">here</ArtprojectLink>.</ArtprojectText>
          )}
          {artproject.path === 'pending' && (
        <ArtprojectText>Visit Magasin IIIs website to read more on the project <ArtprojectLink href="https://magasin3.com/exhibition/sirous-namazi/" target="_blank" rel="noopener noreferrer" aria-label="go to Magasin III website" alt="Magasin III website">here</ArtprojectLink>.
        Read folder online <ArtprojectLink href="https://cdn.magasin3.com/uploads/2023/09/m3_katalog_105x148mm_sn_inlaga_eng_web.pdf" target="_blank" rel="noopener noreferrer" aria-label="Sirous Namazi Pending folder" alt="Sirous Namazi Pending folder">here</ArtprojectLink>.</ArtprojectText>
          )}
        </ArtprojectTextWrapper>
      </ArtprojectContainer>
    </HomeContainer>
  );
};

export default Artproject;